export default "__VITE_ASSET__80340dc8__"